import { render, staticRenderFns } from "./product2.vue?vue&type=template&id=ce8a1c52&scoped=true&"
import script from "./product2.vue?vue&type=script&lang=js&"
export * from "./product2.vue?vue&type=script&lang=js&"
import style0 from "./product2.vue?vue&type=style&index=0&id=ce8a1c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8a1c52",
  null
  
)

export default component.exports